import { reDraw } from '@chart/core/create/redraw/redraw';
import { dispatchPriceHoverEvent } from '@chart/core/events/events';
import { BaseChartAPIProps } from '@chart/types/create.types';

import { ChartStoreReturn } from '../create/chart-store/chartStore';

export const onMouseLeave = (chartStore: ChartStoreReturn) => {
  const base = chartStore.getState().base as BaseChartAPIProps;
  dispatchPriceHoverEvent({
    base,
    priceHover: undefined,
  });
  reDraw({ chartStore });
};
